import {memo, useMemo} from "react";
import {ClientDiagramConnection, ClientDiagramNode} from "../../utility/types";
import {DiagramNodeId} from "platformed-client/types";
import {Label} from "./Label";
import {generateConnectionPath, getConnectionWaypoints, getPathMidPoint} from "../../utility/connectionPath";

export const ConnectionLabel = memo(
  ({
    connection,
    nodes,
  }: {
    connection: ClientDiagramConnection;
    nodes: ReadonlyMap<DiagramNodeId, ClientDiagramNode>;
  }) => {
    const coords = useMemo(() => {
      const waypoints = getConnectionWaypoints(connection, nodes);
      const path = generateConnectionPath(waypoints);
      return getPathMidPoint(path);
    }, [connection, nodes]);

    return <Label label={connection.label} coords={coords} height={12} variant="subtle" />;
  },
);
